interface ErrorPanelProps {
  message: string;
  onRetry?: () => void;
}

const UNWIRED_KEYWORDS = ["not yet wired", "backend endpoint", "pending"];

function isUnwiredError(message: string): boolean {
  return UNWIRED_KEYWORDS.some((kw) => message.includes(kw));
}

/**
 * Displays an error state with an optional Retry affordance.
 * Sanitises "not yet wired" developer messages into user-friendly text.
 */
export function ErrorPanel({ message, onRetry }: ErrorPanelProps) {
  const display = isUnwiredError(message)
    ? "This feature is not yet available. Please check back later."
    : message;

  return (
    <div className="border border-border rounded-lg p-12 text-center space-y-4">
      <p className="text-destructive">{display}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="text-sm text-primary underline hover:no-underline"
        >
          Retry
        </button>
      )}
    </div>
  );
}
